import { useEffect, useState } from 'react';
import { Card } from '@client/new/components/Card';
import { ToggleButtonGroup } from '@client/new/components/ToggleButtonGroup/ToggleButtonGroup';
import {
  TabHash,
  useInfluencerAnalyticsTabs,
} from '@client/pages/metabase/useInfluencerAnalyticsTabs';
import auth from '@client/components/auth';
import { useGetInfluencersQuery } from 'generated/graphql';
import * as enums from '@playbook-technologies/common-enums';
import { MetabaseDashboards, getDashboardUrl } from '@client/api/MetabaseApi';
import { mixTrack } from '@services/mixpanel';

function useMetabaseAnalytics(
  dashboardName: MetabaseDashboards,
  influencer: {
    id: number;
    firstName: string;
    lastName: string;
  },
) {
  const [dashboardUrl, setDashboardUrl] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const currentUserValue = {
    value: influencer.id,
    label: `${influencer.firstName} ${influencer.lastName} (${influencer.id})`,
  };
  const playbookOrganicValue = {
    value: null,
    label: 'Playbook (Organic)',
  };
  const [selectedInfluencer, setSelectednfluencer] = useState(
    influencer.id ? currentUserValue : playbookOrganicValue,
  );
  const influencersQuery = useGetInfluencersQuery({
    variables: {
      mode: enums.Influencer.Mode.Live.value,
    },
  });
  const liveInfluencersList = influencersQuery.data?.creators || [];

  const onInit = async () => {
    setIsLoading(true);
    const { url } = await getDashboardUrl(dashboardName, {
      influencerId: String(selectedInfluencer.value) || '',
    });
    setDashboardUrl(url as string);
    setIsLoading(false);

    mixTrack({
      type: 'Performance Viewed',
      payload: {
        'Product Type': dashboardName,
      },
    });
  };

  useEffect(() => {
    onInit();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedInfluencer, dashboardName]);

  const display = {
    influencerSelect:
      auth.isAdministrator() || auth.isModerator() || auth.isContentEditor(),
  };

  return {
    isLoading,
    dashboardUrl,
    selectedInfluencer,
    liveInfluencersList,
    display,
  };
}

export const Analytics = ({
  creator,
}: {
  creator: {
    id: number;
    firstName: string;
    lastName: string;
  };
}) => {
  const [hash, setHash] = useState<TabHash>('subscriptions');
  const tabs = useInfluencerAnalyticsTabs();
  const tabOptions = tabs.map(([value, label]) => ({ value, label }));
  const metabase = useMetabaseAnalytics(
    hash === 'subscriptions' ? 'SubscriptionPaidAds' : 'OTPPaidAds',
    creator,
  );
  return (
    <div className="flex flex-col gap-4">
      <ToggleButtonGroup<TabHash>
        toStringValue={String}
        toValue={(v) => v as TabHash}
        value={hash}
        onChange={(_, v) => setHash(v)}
        options={tabOptions}
      />

      <Card variant="basic" rounded="2xl" className="px-5 py-0 min-h-24	">
        <iframe
          src={metabase.dashboardUrl}
          width="100%"
          style={{ height: 'calc(100vh - 200px)' }}
        />
      </Card>
    </div>
  );
};
